import React from 'react';
import { ReactComponent as LoaderIcon } from '../../img/loader_thin.svg';
import styles from './DetailsPageLoader.module.scss';

const DetailsPageLoader = () => {
  return <div className={styles.fullPage}><LoaderIcon className={styles.icon} /></div>;
};

export default DetailsPageLoader;
